import { useState, useEffect } from "react";
import { useAlert } from "../../../../context/AlertContext";
import { Card, Button, Col, Row, Container, Tabs, Tab } from "react-bootstrap";
import { useWebsiteName } from "../../../../context/WebsiteNameContext";
import CalendarComponent from "../../../../components/CalendarComponent";
import {
  getServiceRequest,
} from "../../../../commons/ServiceRequest";
import Table from "../../../../components/Table";
import { formatInputDate } from "../../../../utils/Time";
import CalendarTeamComponent from "../../../../components/CalendarTeamComponent";
import moment from "moment";
import TechnicianPlansService from "../../../../services/technicianplan.service";
import { getQueryString } from "../../../../utils/Query";
import PropTypes from "prop-types";
import { formatDate } from "../../../../commons/FormatValue";

export default function WorkCalendar({ defaultData }) {
  const { showAlert } = useAlert();
  const { websiteName, setWebsiteName } = useWebsiteName();
  const [data, setData] = useState();
  const [dataTable, setDataTable] = useState([]);
  const [loading, setLoading] = useState(false);

  const columns = [
    {
      name: "ลำดับ",
      selector: (row) => row.rowIndex,
      sortable: true,
      width: "110px"
    },
    {
      name: "ประเภทงาน",
      selector: (row) => row.Job_Type_Des,
      sortable: true
      //width: "250px"
    },
    {
      name: "จำนวน",
      selector: (row) => row.Count,
      sortable: true,
      sortable: true,
      width: "150px"
    }
  ];

  useEffect(() => {
    const firstDayOfMonth = (moment().startOf("month").add(-6, 'days').toDate()).toISOString()
    const lastDayOfMonth = (moment().endOf("month").add(6, 'days').toDate()).toISOString()
    getDatas(firstDayOfMonth, lastDayOfMonth)
  }, []);

  function getDatas(start, end) {
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: TechnicianPlansService.getTechnicianPlanningCalendar(
        getQueryString({
          // plan_status: "",
          page: 1,
          limit: 1000,
          start: start,
          end: end
        })
      ),
      callback: (res) => {
        settingData(res?.data)
      }
    });
  }

  function uniqArrayByDate(data, key) {
    return [
      ...new Map(data.map(x => [key(x), {
        date: key(x),
        data: data.filter(data => data.job_actual_date == key(x))
        // installJob: data.filter(data => data.job_actual_date == key(x)).filter(el => el.SeqInstalljob),
        // repairJob: data.filter(data => data.job_actual_date == key(x)).filter(el => el.RepairJobs),
        // otherJob: data.filter(data => data.job_actual_date == key(x)).filter(el => el.SeqOthersJob)
      }])).values()
    ]
  }
  const settingData = (resData) => {
    // console.log(resData)
    const arrDate = uniqArrayByDate(resData, ele => ele.job_actual_date)

    const newArray = arrDate.map(el => {

      const objJobType = el.data.reduce((acc, value) => {
        const job_type_name = defaultData?.job_type.find(job => job.Id == (
          value.SeqOthersJob?.Job_Type_Id ||
          value.RepairJobs?.job_type_id ||
          value?.SeqInstalljob?.job_type_id))?.Job_Type_Name
          || ""
        acc[job_type_name] = (acc[job_type_name] || 0) + 1
        return acc
      }, {})
      return { ...el, objJobType: objJobType }
    })
    setData(newArray)

    return
    const newArrays = resData.map((items) => {
      const title = defaultData?.job_type.find(job => job.Id == items.TechnicianReceive[0]?.job_type_id)?.Job_Type_Name

      const jobTypeDesArray = resData.map(
        (item) =>
          item.TechnicianReceive[0]?.job_type_id
      );
      console.log('jobTypeDesArray', jobTypeDesArray)
      const jobTypeDesCount = jobTypeDesArray?.reduce((acc, jobTypeDes) => {
        acc[jobTypeDes] = (acc[jobTypeDes] || 0) + 1;
        return acc;
      }, {});

      const jobTypeDesData = Object.entries(jobTypeDesCount).map(
        ([jobTypeDes, count]) => ({
          Job_Type_Des: jobTypeDes,
          Count: count
        })
      );

      return {
        title: title,
        date: new Date(items.job_actual_date),
        // count: jobTypeDesData
        // start: new Date(items.job_actual_date),
        // end: new Date(items.job_actual_date),
      };
    });
  };

  // const setDataTable = () => {
  //
  // };
  useEffect(() => {
    if (data && !selectDate) {
      setSelectDate(moment(new Date()).format("DD/MM/YYYY"))
    }
  }, [data])
  const [selectDate, setSelectDate] = useState()
  // console.log(selectDate, data)
  useEffect(() => {
    // setDataTable(data.filter(el => moment(el.date).format("DD/MM/YYYY") == selectDate))
    const arr = []
    const selectData = (data?.filter(el => moment(el.date).format("DD/MM/YYYY") == selectDate))
    if (selectData?.length) {
      Object.entries(selectData[0].objJobType).forEach(([key, value]) => {
        arr.push({
          Job_Type_Des: key,
          Count: value
        })
      })
      setDataTable(arr)
    } else {
      setDataTable([])
    }
  }, [selectDate])

  return (
    <>
      <Container fluid className="p-0">
        <Card className="m-1 mb-4 p-4 border-0">
          <Card.Header className="p-3 pb-1 bg-transparent border-bottom-0">
            <Card.Title className="mb-0 fs-2 text-center">
              แผนงานของช่างปฎิบัติงาน
            </Card.Title>
          </Card.Header>

          <Card.Body>
            <CalendarTeamComponent events={data || []} selectDate={selectDate} setSelectDate={setSelectDate}
              onRangeChange={(event) => {
                getDatas(
                  formatDate(event.start, 'YYYY-MM-DD'),
                  formatDate(event.end, 'YYYY-MM-DD')
                )
              }}
            />
            <br />
            <Container>
              <Table
                // data={dataCount.filter(event => (moment(event.date).format("DD/MM/YYYY") == selectDate))}
                data={dataTable}
                column={columns}
                pending={loading}
              />
            </Container>
          </Card.Body>
        </Card>

      </Container>
    </>
  );
}

WorkCalendar.propTypes = {
  defaultData: PropTypes.object,
};